import EpochPage from "./EpochPage";

export default EpochPage;